import {
  Alert,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Row,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";

import { CancelButton, SaveButton } from "../../elements/ActionButtons/index";
import { FormattedMessage, injectIntl } from "react-intl";

import Button from "../../elements/CustomButton/CustomButton";
import Card from "../Card/Card";
import Cleave from "cleave.js/react";
import CollaboratorActionButton from "./CollaboratorActionButton";
import CurrencySelect from "../Currency/CurrencySelect";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import PhoneInput from "../Phone/PhoneInput";
import Radio from "../../elements/CustomRadio/CustomRadio.jsx";
import React from "react";
import SlidingPane from "react-sliding-pane";
import SuperpositionHeader from "../Header/SuperpositionHeader";
import { viewPortDimension } from "../../tools/viewportDimension";
import { withRouter } from "react-router-dom";

import TaxParamsCard from "../Tax/TaxParamsCard";
import TiersXtraDataCard from "../Tiers/tiersXtraDataCard";


const changeCollaboratorEmailToolTips = (
  <Tooltip id="changeCollaboratorEmailToolTips">
    <FormattedMessage id="ids_changeCollaboratorEmailToolTips" />
  </Tooltip>
);


class CollaboratorForm extends React.Component {
  constructor(props) {
    super(props);
    console.log("41 - CollaboratorForm constructor", props);

    this.INITIAL_STATE = {
      email: "",
      name: "",
      firstName:
        (this.props.inputName && this.props.inputName.split(" ")[0]) || "",
      lastName:
        (this.props.inputName && this.props.inputName.split(" ")[1]) || "",
      fixPhone: "",
      mobilePhone: "",
      taxableValue: this.props.collaborator ? this.props.collaborator.taxableValue : null,
      externalCodeValue: this.props.collaborator ? this.props.collaborator.externalCodeValue : "",
      escomptePercentValue: this.props.collaborator ? this.props.collaborator.escomptePercentValue : "0.0",

      iban: "",
      swift: "",
      taxIdemCompany: this.props.collaborator ? this.props.taxIdemCompany : true,
      tax1: this.props.companyDefaultInfos.company.tax1,
      tax2: this.props.companyDefaultInfos.company.tax2,
      currency: this.props.currency && this.props.currency.id,
      role: this.props.comptableOnly ? "COMPTABLE" : "CLIENT",
      isPaneOpen: false,
      invite: this.props.invite || false,
      notifBankTransactions: this.props.notifBankTransactions || true,
      notifBankAlerts: this.props.notifBankAlerts || true,
      validation: null
    };

    console.log("this.INITIAL_STATE=", this.INITIAL_STATE);

    this.state = props.collaborator ? props.collaborator : this.INITIAL_STATE;
    this.state.isPaneOpen = false;

    this.state.taxableValue = props.collaborator && props.collaborator.taxableValue ? props.collaborator.taxableValue : "ENCAISSEMENT";
    this.state.externalCodeValue = props.collaborator && props.collaborator.externalCodeValue ? props.collaborator.externalCodeValue : "";
    this.state.escomptePercentValue = props.collaborator && props.collaborator.escomptePercentValue ? props.collaborator.escomptePercentValue : "0.0";

    console.log("67 - STATE=", this.state);
  }

  componentDidUpdate(prevProps) {
    console.log('71 - prevProps=', prevProps);
    console.log('72 - props=', this.props);

    if (
      this.props.notifBankAlerts !== undefined &&
      this.props.notifBankTransactions !== undefined && (
        prevProps.notifBankAlerts !== this.props.notifBankAlerts ||
        prevProps.notifBankTransactions !== this.props.notifBankTransactions
      )
    ) {
      this.setState({
        notifBankAlerts: this.props.notifBankAlerts,
        notifBankTransactions: this.props.notifBankTransactions
      });
    }
  }

  updateFormValue(key, target) {
    console.log("updateFormValue", key, target);

    if (key === "email") {

      // email required
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      re.test(target.value) === false
        ? this.setState({ validation: { emailValidation: "error" } })
        : this.setState({ validation: { emailValidation: null } });

      if (
        this.props.getNewCollaboratorDataFromUsers &&
        this.props.getNewCollaboratorDataFromUsers
          .getNewCollaboratorDataFromUsers
      ) {
        this.props.getNewCollaboratorDataFromUsers.getNewCollaboratorDataFromUsers.forEach(
          (value, key, map) => {
            if (target.value === value.email) {
              this.setState({
                firstName: value.firstname,
                lastName: value.name,
                fixPhone: value.telFixe,
                mobilePhone: value.telMobile
              });
            }
          }
        );
      }
    }

    this.setState({
      [key]: target ? target.value : ""
    });
  }

  onCancel() {
    this.setState(
      this.props.collaborator ? this.props.collaborator : this.INITIAL_STATE
    );
  }

  onSubmit() {
    if (this.state && this.state.email === "")
      return;

    this.props.onSubmit(this.state);
  }

  renderRoleWarning() {
    let { comptableOnly, odooMenu } = this.props;

    if (odooMenu === true) {
      return (
        <div></div>
      )
    }

    if (comptableOnly && this.state.role === "COMPTABLE") {
      return (
        <Alert bsStyle="warning">
          <FormattedMessage id="ids_comptableRightsExplanation" />
        </Alert>
      );
    }
    if (!comptableOnly && this.state.role === "CLIENT") {
      return (
        <Alert bsStyle="warning">
          <FormattedMessage id="ids_collaboratorRightsExplanation" />
        </Alert>
      );
    }
    if (!comptableOnly && this.state.role === "COMMERCIAL") {
      return (
        <Alert bsStyle="warning">
          <FormattedMessage id="ids_commercialRightsExplanation" />
        </Alert>
      );
    }
    if (!comptableOnly && this.state.role === "ADMIN") {
      return (
        <Alert bsStyle="warning">
          <FormattedMessage id="ids_adminRightsExplanation" />
        </Alert>
      );
    }
  }

  showDeleteSlidingPane = () => {
    if (this.state.role === "COMPTABLE") {
      this.setState({
        isPaneOpen: true,

        paneTitleIds: this.props.intl.formatMessage({
          id: "ids_comptableDeletion"
        }),
        paneContentIds: this.props.intl.formatMessage({
          id: "ids_confirmDeleteComptable"
        }),
        ids_paneActionSuccess: this.props.intl.formatMessage({
          id: "ids_comptableHasBeenDeleted"
        }),
        ids_paneActionFailed: this.props.intl.formatMessage({
          id: "ids_errorComptableCouldNotBeDeleted"
        }),

        paneConfirmAction: async () => {
          return await this.props.deleteCollaborator();
        }
      });
    } else {
      this.setState({
        isPaneOpen: true,

        paneTitleIds: this.props.intl.formatMessage({
          id: "ids_collaboratorDeletion"
        }),
        paneContentIds: this.props.intl.formatMessage({
          id: "ids_confirmDeleteCollaborator"
        }),
        ids_paneActionSuccess: this.props.intl.formatMessage({
          id: "ids_collaboratorHasBeenDeleted"
        }),
        ids_paneActionFailed: this.props.intl.formatMessage({
          id: "ids_errorCollaboratorCouldNotBeDeleted"
        }),

        paneConfirmAction: async () => {
          return await this.props.deleteCollaborator();
        }
      });
    }
  };

  onPaneConfirm = async event => {
    console.log("OnPaneConfirm 003");

    this.setState({ actionRunning: true });

    let bTest = await this.state.paneConfirmAction(event);

    if (
      bTest &&
      bTest.data &&
      bTest.data.deleteTiersAfterCheck &&
      bTest.data.deleteTiersAfterCheck.result
    ) {
      this.setState({ actionRunning: false });

      let notif = NotificationProvider.getSuccessNotification();
      notif.message = this.state.ids_paneActionSuccess;
      this.props.sendNotification(notif);

      this.setState({ isPaneOpen: false });

      if (this.state.role === "COMPTABLE") {
        setTimeout(() => {
          this.props.history.push("/comptables");
        }, 1500);
      } else {
        setTimeout(() => {
          this.props.history.push("/collaborators");
        }, 1500);
      }
    } else {
      let notif = NotificationProvider.getFailureNotification();
      notif.message = this.state.ids_paneActionFailed;

      this.setState({ isPaneOpen: false });
      this.props.sendNotification(notif);
    }
  };

  renderActionButton() {
    if (this.props.role === "ADMIN") {
      return (
        <CollaboratorActionButton
          availableActions={["DELETECOLLABORATOR"]}
          deleteCollaborator={() => {
            console.log("call showDeleteCollaboratorSlidingPane", this);
            this.showDeleteSlidingPane();
          }}
        />
      );
    } else {
      return <div />;
    }
  }

  renderHeader(backBtnText, collaborator) {
    if (!this.props.inSideModal) {
      return (
        <SuperpositionHeader
          backBtnText={backBtnText}
          handleMinimizeSidebar={this.props.handleMinimizeSidebar}
        >
          <div className="space-between">
            <div>{!collaborator ? <div /> : this.renderActionButton()}</div>
            {/* <div>
              {this.props.role === "ADMIN" && (
                <CancelButton onClick={() => this.onCancel()} />
              )}
            </div> */}
            <div>
              {this.props.role === "ADMIN" && (
                <SaveButton
                  onClick={() => this.onSubmit()}
                  className="btn-fill pull-right margin-left-20"
                />
              )}
            </div>
          </div>
        </SuperpositionHeader>
      );
    }
    return <div />;
  }

  renderButton() {
    if (this.props.inSideModal) {
      return (
        <div className="side-modal-footer">
          <CancelButton onClick={this.props.cancel} />
          <SaveButton
            onClick={() => this.onSubmit()}
            className="btn-fill pull-right margin-left-20"
          />
        </div>
      );
    }
    return <div />;
  }

  renderForm() {
    console.log("Role", this.state.role);
    // console.log("324 - this.props.odooMenu=", this.props.odooMenu);

    return (
      <FormGroup>
        <Row>

          <Col sm={4}>
            <FormGroup validationState={this.state.validation && this.state.validation.emailValidation}>
              <ControlLabel>
                <FormattedMessage id="ids_email" />
                {this.state.invite === true && (
                  <div>
                    <OverlayTrigger
                      placement="top"
                      overlay={changeCollaboratorEmailToolTips}
                    >
                      <i className="fa fa-info-circle text-primary" />
                    </OverlayTrigger>
                  </div>
                )}
              </ControlLabel>
              <FormControl
                disabled={this.state.invite === true}
                type="email"
                name="email"
                value={this.state.email}
                onChange={e => this.updateFormValue("email", e.target)}
              />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <ControlLabel>
              <FormattedMessage
                id="ids_firstname"
                description="collaborator first name input field label"
                defaultMessage="Prénom"
              />
            </ControlLabel>
            <FormControl
              type="text"
              name="firstName"
              value={this.state.firstName}
              onChange={e => this.updateFormValue("firstName", e.target)}
            />
          </Col>
          <Col sm={4}>
            <ControlLabel>
              <FormattedMessage id="ids_lastname" />
            </ControlLabel>
            <FormControl
              type="text"
              name="lastName"
              value={this.state.lastName}
              onChange={e => this.updateFormValue("lastName", e.target)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <ControlLabel>
              <FormattedMessage id="ids_fixPhone" />
            </ControlLabel>
            <PhoneInput
              value={this.state.fixPhone}
              update={e => this.updateFormValue("fixPhone", e)}
            />
          </Col>
          <Col sm={6}>
            <ControlLabel>
              <FormattedMessage id="ids_mobilePhone" />
            </ControlLabel>
            <PhoneInput
              value={this.state.mobilePhone}
              update={e => this.updateFormValue("mobilePhone", e)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <ControlLabel>
              <FormattedMessage id="ids_iban" />
            </ControlLabel>
            <Cleave
              className="form-control"
              placeholder="FR33 2002 0202 2606 0002 4M02 606"
              name="iban"
              style={{ textTransform: "uppercase" }}
              options={{
                blocks: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
                delimiter: " "
              }}
              value={this.state.iban}
              onChange={e => this.updateFormValue("iban", e.target)}
            />
          </Col>
          <Col sm={4}>
            <ControlLabel>
              <FormattedMessage id="ids_swift" />
            </ControlLabel>
            <Cleave
              className="form-control"
              placeholder="AAA FR 00 000"
              name="swift"
              style={{ textTransform: "uppercase" }}
              // options={{ blocks: [3, 2, 2, 3], delimiter: " " }}
              value={this.state.swift}
              onChange={e => this.updateFormValue("swift", e.target)}
            />
          </Col>
          <Col sm={2}>
            <ControlLabel>
              <FormattedMessage
                id="ids_currency"
                description="client currency input field label"
                defaultMessage="Devise"
              />
            </ControlLabel>
            <CurrencySelect
              value={this.state.currency}
              onSelected={e => this.updateFormValue("currency", e)}
            />
          </Col>
        </Row>

        {/* {this.props.role === "ADMIN" && !!!this.props.comptableOnly && (
          <Row>
            <br />
            <Col sm={6}>
              <ControlLabel className="radio-label">
                <FormattedMessage id="ids_notificationsBankTransactions" />
                <Radio
                  number="5"
                  option={"YES"}
                  name="notifBankTransactions"
                  disabled={this.state.role !== "ADMIN" || this.state.invite !== true}
                  checked={this.state.notifBankTransactions === true}
                  onChange={e =>
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    })
                  }
                  label={<FormattedMessage id="ids_yes" />}
                />
                <Radio
                  number="6"
                  option={"NO"}
                  name="notifBankTransactions"
                  disabled={this.state.role !== "ADMIN" || this.state.invite !== true}
                  checked={this.state.notifBankTransactions === false}
                  onChange={e => {
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    });
                  }}
                  //                  checked={!this.state.invite}
                  label={<FormattedMessage id="ids_no" />}
                />
              </ControlLabel>
            </Col>

            <Col sm={6}>
              <ControlLabel className="radio-label">
                <FormattedMessage id="ids_notificationsBankAlerts" />
                <Radio
                  number="7"
                  option={"YES"}
                  name="notifBankAlerts"
                  disabled={this.state.role !== "ADMIN" || this.state.invite !== true}
                  onChange={e => {
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    });
                  }}
                  checked={this.state.notifBankAlerts === true}
                  label={<FormattedMessage id="ids_yes" />}
                />
                <Radio
                  number="8"
                  option="ADMIN"
                  name="notifBankAlerts"
                  disabled={this.state.role !== "ADMIN" || this.state.invite !== true}
                  onChange={e => {
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    });
                  }}
                  checked={this.state.notifBankAlerts === false}
                  label={<FormattedMessage id="ids_no" />}
                />
              </ControlLabel>
            </Col>
          </Row>
        )} */}

        {this.props.comptableOnly && <div className="margin-top-20" />}
        {this.props.role === "ADMIN" && (
          <Row>
            <br />
            <Col sm={4}>
              <ControlLabel className="radio-label">
                <FormattedMessage id="ids_allowAccess" />
                <Radio
                  number="3"
                  option={"YES"}
                  name="invite"
                  disabled={false && !this.props.isCompanyAdmin}
                  checked={this.state.invite === true}
                  onChange={e =>
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    })
                  }
                  //                  checked={this.state.}
                  label={<FormattedMessage id="ids_yes" />}
                />
                <Radio
                  number="4"
                  option={"NO"}
                  name="invite"
                  disabled={false && !this.props.isCompanyAdmin}
                  checked={this.state.invite === false}
                  onChange={e => {
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    });
                  }}
                  //                  checked={!this.state.invite}
                  label={<FormattedMessage id="ids_no" />}
                />
              </ControlLabel>
            </Col>
            {!this.props.comptableOnly && (
              <Col sm={4}>
                <ControlLabel className="radio-label">
                  <FormattedMessage id="ids_as" />
                  <Radio
                    number="5"
                    option="CLIENT"
                    name="role"
                    disabled={this.state.invite !== true}
                    onChange={e =>
                      this.updateFormValue(e.target.name, e.target)
                    }
                    checked={this.state.role === "CLIENT"}
                    label={<FormattedMessage id="ids_collaborator" />}
                  />
                  {this.props.odooMenu !== true && (
                    <Radio
                      number="1"
                      option="COMMERCIAL"
                      name="role"
                      disabled={this.state.invite !== true}
                      onChange={e =>
                        this.updateFormValue(e.target.name, e.target)
                      }
                      checked={this.state.role === "COMMERCIAL"}
                      label={<FormattedMessage id="ids_respComm" />}
                    />)}
                  <Radio
                    number="2"
                    option="ADMIN"
                    name="role"
                    disabled={this.state.invite !== true}
                    //                  disabled={false && !this.props.isCompanyAdmin}
                    onChange={e =>
                      this.updateFormValue(e.target.name, e.target)
                    }
                    checked={this.state.role === "ADMIN"}
                    label={<FormattedMessage id="ids_administrator" />}
                  />
                </ControlLabel>
              </Col>
            )}
          </Row>
        )}
      </FormGroup>
    );
  }

  renderFormBankAlertMails() {
    return (
      <FormGroup>

        {this.props.role === "ADMIN" && !!!this.props.comptableOnly && this.props.odooMenu !== true && (
          <Row>
            <br />
            <Col sm={6}>
              <ControlLabel className="radio-label">
                <FormattedMessage id="ids_notificationsBankTransactions" />
                <Radio
                  number="5"
                  option={"YES"}
                  name="notifBankTransactions"
                  disabled={this.state.role !== "ADMIN" || this.state.invite !== true}
                  checked={this.state.notifBankTransactions === true}
                  onChange={e =>
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    })
                  }
                  label={<FormattedMessage id="ids_yes" />}
                />
                <Radio
                  number="6"
                  option={"NO"}
                  name="notifBankTransactions"
                  disabled={this.state.role !== "ADMIN" || this.state.invite !== true}
                  checked={this.state.notifBankTransactions === false}
                  onChange={e => {
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    });
                  }}
                  //                  checked={!this.state.invite}
                  label={<FormattedMessage id="ids_no" />}
                />
              </ControlLabel>
            </Col>

            <Col sm={6}>
              <ControlLabel className="radio-label">
                <FormattedMessage id="ids_notificationsBankAlerts" />
                <Radio
                  number="7"
                  option={"YES"}
                  name="notifBankAlerts"
                  disabled={this.state.role !== "ADMIN" || this.state.invite !== true}
                  onChange={e => {
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    });
                  }}
                  checked={this.state.notifBankAlerts === true}
                  label={<FormattedMessage id="ids_yes" />}
                />
                <Radio
                  number="8"
                  option="ADMIN"
                  name="notifBankAlerts"
                  disabled={this.state.role !== "ADMIN" || this.state.invite !== true}
                  onChange={e => {
                    this.updateFormValue(e.target.name, {
                      value: e.target.value === "YES"
                    });
                  }}
                  checked={this.state.notifBankAlerts === false}
                  label={<FormattedMessage id="ids_no" />}
                />
              </ControlLabel>
            </Col>
          </Row>
        )}
      </FormGroup>
    );
  }

  renderFormContainer() {
    if (this.props.inSideModal) {
      return (
        <div>
          {this.renderForm()}
          {this.renderRoleWarning()}
          {this.renderFormBankAlertMails()}
        </div>
      );
    }
    // console.log("704 - this.state=", this.state);
    return (
      <div className="main-content">
        <Grid fluid>
          <div className="main-content">
            <Row>
              <Card>
                {this.renderForm()}
                {this.renderRoleWarning()}
                {this.renderFormBankAlertMails()}
              </Card>
              <TaxParamsCard
                blockCreateOnTaxes={this.props.inSideModal}
                companyId={this.props.companyId}
                tax1={this.state.tax1}
                tax2={this.state.tax2}
                sendNotification={this.props.sendNotification}
                onChange={(key, value) => {
                  // console.log("722 - key/value=", key, value);
                  this.setState({ [key]: value });
                }}
                withIdemCheckBox
                taxIdemCompany={this.state.taxIdemCompany}
                taxableValue={this.state.taxableValue}
                intl={this.props.intl}
              />

              <TiersXtraDataCard
                taxableValue={this.state.taxableValue}
                externalCodeValue={this.state.externalCodeValue}
                escomptePercentValue={this.state.escomptePercentValue}
                companyId={this.props.companyId}
                onChange={(key, value) => this.setState({ [key]: value })}
                intl={this.props.intl}
              />
            </Row>
          </div>
        </Grid>
      </div>
    );
  }

  render() {
    // console.log("743 - CollaboratorForm", this.props, this.state);

    let { comptableOnly, intl, collaborator, odooMenu, defaultMenu } = this.props;

    let backBtnText = "";
    if (!collaborator) {
      backBtnText = (comptableOnly)
        ? intl.formatMessage({ id: "ids_newAccountant" })
        : intl.formatMessage({ id: "ids_newCollaborator" });
    } else {
      backBtnText = collaborator.firstName
        ? `${collaborator.firstName} ${collaborator.lastName}`
        : intl.formatMessage({ id: "ids_edit" });
    }

    // const backBtnText =
    //   match.url.split("/").slice(-1)[0] === "new" && comptableOnly
    //     ? intl.formatMessage({ id: "ids_newAccountant" })
    //     : match.url.split("/").slice(-1)[0] === "new"
    //       ? intl.formatMessage({ id: "ids_newCollaborator" })
    //       : `${collaborator.firstName} ${collaborator.lastName}` ||
    //         intl.formatMessage({ id: "ids_edit" });

    const dimension = viewPortDimension();
    const slidingPaneWidth =
      Math.min(dimension.width - 200, 800).toString() + "px";

    return (
      <div>
        <SlidingPane
          isOpen={this.state.isPaneOpen}
          title={this.state.paneTitleIds}
          width={slidingPaneWidth}
          onRequestClose={() => this.setState({ isPaneOpen: false })}>
          <div>
            <p>{this.state.paneContentIds}</p>
            <FormGroup>
              <CancelButton
                onClick={() => this.setState({ isPaneOpen: false })}
              />
              <Button
                icon
                fill
                wd
                bsStyle="primary"
                onClick={event => this.onPaneConfirm(event)}>
                <i className="fa fa-lg fa-check" />
                <FormattedMessage id="ids_confirm" />
              </Button>
            </FormGroup>
          </div>
        </SlidingPane>
        {this.renderHeader(backBtnText, collaborator)}
        <Grid fluid>
          {this.renderFormContainer()}
          {this.renderButton()}
        </Grid>
      </div>
    );
  }
}

export default withRouter(injectIntl(CollaboratorForm));
